import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, Radio, RadioGroup, FormControlLabel, Grid,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/en-US';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import {
  Button, Input, Label,
} from '@ipc/ipc-components';
import { StyledModalForm } from '../../../../../common/list-table/helpers/formModal.styles';

function HandlersEditDialog(props) {
  const [printReceipt, updatePrintReceipt] = useState(true);
  const [newValidFrom, updateNewValidFrom] = useState(null);
  const [validTo, updateValidTo] = useState(null);
  const [isFormValid, updateFormValidity] = useState(true);

  const {
    isOpen,
    selectedHandler,
    handleCancel,
    handleSubmit,
  } = props;

  useEffect(() => {
    if (selectedHandler) {
      updatePrintReceipt(selectedHandler.printReceipt);
      updateValidTo(selectedHandler.validTo ? moment(selectedHandler.validTo) : null);
      if (moment(selectedHandler.validFrom).isAfter(moment())) {
        updateNewValidFrom(moment(selectedHandler.validFrom));
      }
    } else {
      updatePrintReceipt(true);
      updateNewValidFrom(null);
      updateValidTo(null);
    }
  }, [selectedHandler]);

  useEffect(() => {
    if (newValidFrom !== null && !newValidFrom.isValid()) {
      updateFormValidity(false);
    } else if (newValidFrom && validTo) {
      updateFormValidity(newValidFrom.isValid() && newValidFrom.isSameOrBefore(validTo));
    } else if (validTo) {
      updateFormValidity(moment(selectedHandler.validFrom).isSameOrBefore(validTo));
    } else updateFormValidity(true);
  }, [newValidFrom, validTo]);
  const handleChange = (event) => {
    updatePrintReceipt(event.target.value === 'true');
  };
  const onChangeValidFrom = (newDate) => {
    updateNewValidFrom(moment(newDate));
  };
  const onChangeValidTo = (newDate) => {
    if (!newDate) {
      updateValidTo(null);
    } else updateValidTo(moment(newDate));
  };

  const onSubmit = () => {
    const requestData = {
      printReceipt,
      validFrom: selectedHandler.validFrom,
      validTo: validTo && typeof validTo.format === 'function' ? validTo.format('YYYY-MM-DD') : null,
      newValidFrom: newValidFrom ? newValidFrom.format('YYYY-MM-DD') : null,
    };
    handleSubmit(requestData);
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle id="simple-dialog-title">Edit Handler Settings</DialogTitle>
      <StyledModalForm>
        <table className="form-details">
          <tbody>
            <tr>
              <td className="form-input-fields">
                <Label>Handler Name</Label>
              </td>
              <td className="disabled-input-handler form-input-fields">
                <Input
                  type="text"
                  id="destination"
                  value={selectedHandler?.handlerName}
                  disabled
                />
              </td>
            </tr>
            <tr>
              <td className="form-input-fields">
                <Label>Print Receipt*</Label>
              </td>
              <td className="form-input-fields">
                <RadioGroup aria-label="printReceipt" name="printReceipt" value={printReceipt} onChange={handleChange}>
                  <FormControlLabel value control={<Radio />} label="Yes" />
                  <FormControlLabel value={false} control={<Radio />} label="No" />
                </RadioGroup>
              </td>
            </tr>
            <tr>
              <td className="form-input-fields">
                <Label>Valid from*</Label>
              </td>
              <td className="form-input-fields handler-picker">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disablePast={!!newValidFrom}
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline from"
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      value={!newValidFrom ? moment(selectedHandler?.validFrom) : newValidFrom}
                      onChange={onChangeValidFrom}
                      disabled={!newValidFrom}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
            <tr>
              <td className="form-input-fields">
                <Label>Valid to</Label>
              </td>
              <td className="form-input-fields handler-picker">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disablePast
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline to"
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      minDate={newValidFrom || moment(selectedHandler?.validFrom)}
                      value={validTo}
                      onChange={onChangeValidTo}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="after-box">
          <Button className="cancel" onClick={handleCancel}>Cancel</Button>
          <Button
            onClick={onSubmit}
            className={`primary-button-${!isFormValid} action`}
            disabled={!isFormValid}
          >
            Save
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}

HandlersEditDialog.propTypes = {
  isOpen: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  selectedHandler: PropTypes.shape({
    handlerName: PropTypes.string,
    printReceipt: PropTypes.bool,
    validFrom: PropTypes.string,
    validTo: PropTypes.string,
  }),
};

export default HandlersEditDialog;
